import React, { useEffect } from "react";
import {
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import QuienesSomos from "./components/QuienesSomos";
import Productos from "./components/Productos";
import Contacto from "./components/Contacto";
import Ubicacion from "./components/Ubicacion";
import Footer from "./components/Footer";
import ProcesoProductivo from "./components/ProcesoProductivo";
import SectoresSubnav from "./components/SectoresSubnav";
import {
  ControlDeCalidadPage,
  DisenoYDesarrolloPage,
  SustentabilidadPage,
} from "./components/SectorPages";
import "./index.css";

function ScrollToSection() {
  const location = useLocation();

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      const section = location.hash.slice(1) || location.state?.scrollTo;
      if (section) {
        document.getElementById(section)?.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
        });
      } else {
        window.scrollTo({ top: 0, behavior: "instant" });
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [location]);

  return null;
}

function App() {
  const location = useLocation();

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const elements = new WeakSet();

    const revealImmediately = (element) => {
      element.setAttribute("data-scroll-revealed", "");
    };

    const observer = prefersReducedMotion
      ? null
      : new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                revealImmediately(entry.target);
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.08,
            rootMargin: "0px 0px 18% 0px",
          }
        );

    const observeRevealElements = () => {
      document.querySelectorAll("[data-scroll-reveal]").forEach((element) => {
        if (elements.has(element)) {
          return;
        }

        elements.add(element);

        if (element.dataset.scrollRevealDelay) {
          element.style.transitionDelay = element.dataset.scrollRevealDelay;
        }

        if (prefersReducedMotion) {
          revealImmediately(element);
          return;
        }

        observer.observe(element);
      });
    };

    observeRevealElements();

    const mutationObserver = new MutationObserver(observeRevealElements);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer?.disconnect();
      mutationObserver.disconnect();
    };
  }, [location.key]);

  return (
    <div className="App">
      <a className="skip-link" href="#contenido">Saltar al contenido</a>
      <Navbar />
      <ScrollToSection />
      <main id="contenido" tabIndex={-1} key={location.pathname} className="animate-fade-up">
          <Routes location={location}>
            <Route
              path="/"
              element={
                <>
                  <QuienesSomos id="quienes-somos" />
                  <Productos id="productos" />
                  <Contacto id="contacto" />
                  <Ubicacion id="ubicacion" />
                </>
              }
            />
            <Route
              path="/sectores/proceso_productivo"
              element={
                <>
                  <SectoresSubnav />
                  <ProcesoProductivo />
                </>
              }
            />
            <Route
              path="/sectores/control_de_calidad"
              element={
                <>
                  <SectoresSubnav />
                  <ControlDeCalidadPage />
                </>
              }
            />
            <Route
              path="/sectores/diseno_y_desarrollo"
              element={
                <>
                  <SectoresSubnav />
                  <DisenoYDesarrolloPage />
                </>
              }
            />
            <Route
              path="/sectores/sustentabilidad"
              element={
                <>
                  <SectoresSubnav />
                  <SustentabilidadPage />
                </>
              }
            />
          </Routes>
      </main>
      <Footer />
      {/* <a
        href="https://wa.me/1234567890" // Reemplaza con tu número de WhatsApp
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4"
      >
        <img
          src={whatsappIcon}
          alt="WhatsApp"
          className="w-20 h-20"
        />
      </a> */}
    </div>
  );
}

export default App;
